import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { SearchBarMain } from '../components/header/SearchBarMain';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const SearchPlayersBarDialog = ({ close, open }: PropTypes) => {
  const navigate = useNavigate();

  const handleSelect = (user: any) => {
    if (!user) return;
    navigate(`/profile/overview/${user._id}`);
    close();
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      PaperProps={{
        style: {
          position: 'absolute',
          top: '10%',
        },
      }}
    >
      <SearchBarMain
        handleSelect={handleSelect}
        headerHeight={56}
        hideBackdrop
        fullWidth
      />
    </Dialog>
  );
};
